export default {
  files: [],
  file_categories: [],
  file: {},
  pedding_files: 0,
  pagination: {
    current_page: 1,
    per_page: 15,
    orderBy: "",
    sortBy: "asc",
  },
  estrutura: [],
  loading: false,
};
